var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgReply = function SvgReply(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 800,
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#949494",
    fillRule: "nonzero",
    d: "m14.222 23 6.208 6.207a1.75 1.75 0 0 1-2.35 2.589l-.125-.114-9.192-9.192a1.75 1.75 0 0 1-.114-2.35l.114-.125 9.192-9.192a1.75 1.75 0 0 1 2.588 2.35l-.113.124-6.204 6.203H22c3.342 0 6.455.743 9.157 2.167l.402.219a17.012 17.012 0 0 1 6.555 6.555C39.68 31.234 40.5 34.49 40.5 38a1.75 1.75 0 0 1-3.5 0c0-2.92-.671-5.587-1.939-7.847a13.512 13.512 0 0 0-5.214-5.214c-2.135-1.197-4.632-1.863-7.363-1.933L22 23h-7.778l6.208 6.207L14.222 23Z"
  })));
};
export default SvgReply;